const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN_BY_TOKEN: 'user/LOGIN_BY_TOKEN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  UMK_LOGIN: 'user/UMK_LOGIN',
  UMK_REGISTER: 'user/UMK_REGISTER',
  UMK_CHANGEPW: 'user/UMK_CHANGEPW',
  SET_RESET_PW: 'user/SET_RESET_PW',
  BASIC_REGISTER: 'user/BASIC_REGISTER',
  BASIC_LOGIN: 'user/BASIC_LOGIN',
  SELECT_WORKSPACE: 'user/SELECT_WORKSPACE',
  SET_WORKSPACE_NAME: 'user/SET_WORKSPACE_NAME',
  SET_USER_NAME: 'user/SET_USER_NAME',
  SET_USER_AVATAR: 'user/SET_USER_AVATAR',
  SET_LEAKED_RECORD_COUNT: 'user/SET_LEAKED_RECORD_COUNT',
  // 플랜(요금제) 재조회 — 서버가 플랜 관련 거부(491~494/588)를 돌려줬을 때
  // stale 라이선스를 갱신해 다음 시도부터 UI 게이트가 새 정책과 일치하게 만든다.
  RELOAD_PAID_LICENSE: 'user/RELOAD_PAID_LICENSE',
} as const

export type UserActionTypes = typeof actions

export default actions
